import Button from '@clayui/button';
import React from 'react';
import './CutButton.css';
interface CSSVarProps extends React.CSSProperties {
    [key: string]: string | number | undefined;
}
 
interface CutButtonProps {
    title: string;
    primaryButtonStyle?: React.CSSProperties | CSSVarProps;
    onClick?: () => void;
    buttonType: 'button' | 'submit' | 'reset';
    disabled: boolean;
}

const CutButton: React.FC<CutButtonProps> = ({
    title,
    primaryButtonStyle,
    onClick,
    buttonType,
    disabled
}) => {
    const primaryDefaultButtonStyle = {
        '--parent-bg-background': '#003764',
        '--bg-cut-background': '#003764'
    } as React.CSSProperties;

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <div className="basic-details-button-section">
            <Button
                type={buttonType}
                disabled={disabled}
                className="customer-bottom-cut"
                style={primaryButtonStyle ? primaryButtonStyle : primaryDefaultButtonStyle}
                onClick={handleClick}
            >
                <span className="customer-bottom-cut-span"></span>
                {title}
            </Button>
        </div>
    );
};

export default CutButton;
